import { Skeleton } from '../Skeleton';

export const CarouselPillSkeleton = () => <Skeleton height={64} width={100} />;
